<template>
  <div class="upload-file">
    <template v-if="currentImage">
      <div
        class="text-center preview-img"
        style="
          overflow: hidden;
          min-height: 150px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        "
        :style="{
          'min-height': height + 'px',
          'background-image': 'url(\'' + showImage + '\')'
        }"
      >
        <template v-if="loading">
          <div
            style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
          >
            <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
          </div>
        </template>
        <div v-else class="overlay">
          <v-layout
            justify-center
            fill-height
            align-center
            row
            class="mb-0"
            style="min-height: 100%"
            :style="{ 'min-height': height + 'px' }"
          >
            <div v-if="!disabled" @click="onClickUploadButton">
              <slot>
                <v-btn small depressed color="primary" style="font-size: 11px">
                  <span class="fa fa-camera mr-1"></span>
                  {{ $t('select file to upload') }}
                </v-btn>

                <div class="caption text-xs-center" style="color: white">
                  {{ $t('upload file size: {size}MB', { size: 10 }) }}
                </div>
              </slot>
            </div>
          </v-layout>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text-xs-center">
        <div
          style="min-height: 150px; background: #eee; overflow: hidden; position: relative"
          :style="{ 'min-height': height + 'px' }"
        >
          <template v-if="loading">
            <div
              style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            >
              <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
            </div>
          </template>
          <template v-else>
            <v-layout
              justify-center
              fill-height
              align-center
              row
              class="mb-0"
              style="min-height: 100%"
              :style="{ 'min-height': height + 'px' }"
            >
              <div v-if="!disabled" @click="onClickUploadButton">
                <slot>
                  <v-btn small depressed color="primary" style="font-size: 11px">
                    <span class="fa fa-camera mr-1"></span>
                    {{ $t('select file to upload') }}
                  </v-btn>

                  <div class="caption grey--text text-xs-center">
                    {{ $t('upload file size: {size}MB', { size: 10 }) }}
                  </div>
                </slot>
              </div>
            </v-layout>
          </template>
        </div>
      </div>
    </template>
    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      v-validate="'image|size:10240|mimes:image/jpeg,image/png,image/jpg,image/gif'"
      accept=".jpg, .png, .jpeg, .gif"
      :multiple="multiple"
      @change="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
    <div class="error--text caption" v-if="errors.has('photoUpload')">
      {{ errors.first('photoUpload') }}
    </div>
  </div>
</template>
<script>
import UploadSingleFile from './UploadSingleFile.js'
export default {
  mixins: [UploadSingleFile]
}
</script>



// WEBPACK FOOTER //
// src/components/elements/uploadfile.vue